/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/button/css/button';
import '@swisslife/patterns-base/src/atoms/heading/css/heading';
import '@swisslife/patterns-base/src/atoms/image/css/image';
import '@swisslife/patterns-base/src/atoms/list/css/list';
import '@swisslife/patterns-base/src/atoms/text/css/text';
import '../../quick-links/css/quick-links';
import './mood-image-conversion.scss';
import './modifier/box.scss';
import './modifier/image.scss';
import './modifier/quick-links.scss';
